import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';
import { ExpenseItem } from './store/expense-item.model';
import { environment } from '../../environments/environment';
// import { IServiceItem, ITask, IUserGroup } from '../lookups';

@Injectable({
    providedIn: 'root'
})
export class ExpenseItemService {
    constructor(private http: HttpClient, private log: LoggingService) {}

    private uri = `${environment.apiLocation}/ExpenseItem`;

    public getExpenseItems(): Observable<Array<ExpenseItem>> {
        this.log.verbose({
            type: 'ExpenseItemService:getExpenseItems',
            uri: this.uri
        });
        return this.http.get<Array<ExpenseItem>>(this.uri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'ExpenseItemService:response',
                    res
                })
            )
        );
    }

    public postExpenseItems(): Observable<Array<ExpenseItem>> {
        this.log.verbose({
            type: 'ExpenseItemService:postExpenseItems',
            uri: this.uri
        });
        return this.http.post<Array<ExpenseItem>>(this.uri, {}).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'ExpenseItemService:response',
                    res
                })
            )
        );
    }

    public putExpenseItems(
        expenseItems: Array<ExpenseItem>
    ): Observable<IGenericResponse<ExpenseItem>> {
        return this.http
            .put<IGenericResponse<ExpenseItem>>(this.uri, {
                ExpenseItemList: expenseItems
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'ExpenseItemService:putExpenseItems',
                        data
                    })
                )
            );
    }
}
